module.exports = __webpack_public_path__ + "static/27-66cfd5d140055d7a790e6cebd3f1289d.jpg";